import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserNavigationState {
  tab: "Active" | "Inactive" | "Deleted";
}

const initialState: UserNavigationState = {
  tab: "Active", // ✅ default
};

const userNavigationSlice = createSlice({
  name: "userNavigation",
  initialState,
  reducers: {
    setUserTab: (
      state,
      action: PayloadAction<"Active" | "Inactive" | "Deleted">,
    ) => {
      state.tab = action.payload;
    },
  },
});

export const { setUserTab } = userNavigationSlice.actions;
export default userNavigationSlice.reducer;
